import * as React from "react";
const SvgFiRrJpg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-jpg_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h11.343a4.97 4.97 0 0 0 3.535-1.465l2.658-2.656A4.97 4.97 0 0 0 24 16.343V5a5.006 5.006 0 0 0-5-5M2 19V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10h-4a3 3 0 0 0-3 3v4H5a3 3 0 0 1-3-3m16.464 2.121a3 3 0 0 1-1.464.8V18a1 1 0 0 1 1-1h3.922a3 3 0 0 1-.8 1.465zM14 9.084v-2.1a1.991 1.991 0 0 1 3.035-1.69c.312.19.567.461.737.784a.626.626 0 0 1-1.11.58A.78.78 0 0 0 16 6.25a.74.74 0 0 0-.749.75v2.068a.74.74 0 0 0 .749.751.76.76 0 0 0 .75-.735V9h-.25a.5.5 0 0 1 0-1h.75a.75.75 0 0 1 .75.75v.334a2 2 0 0 1-2 1.984 1.99 1.99 0 0 1-2-1.984M8 5.65v3.356a2.07 2.07 0 0 1-2.079 2.063A2.11 2.11 0 0 1 4.072 9.9a.651.651 0 1 1 1.162-.587.82.82 0 0 0 .687.459.77.77 0 0 0 .779-.783v-3.34A.65.65 0 1 1 8 5.65M11.09 5H10a1 1 0 0 0-1 1v4.444a.625.625 0 1 0 1.25 0V9.223h.84a2.11 2.11 0 1 0 0-4.223m0 2.969h-.832l-.006-1.719h.838a.86.86 0 1 1 0 1.719"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-jpg_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrJpg;
